import { Base64 } from 'js-base64';

const parseJWT = token => {
  if (!token) {
    return null;
  }

  try {
    return JSON.parse(Base64.decode(token.split('.')[1]));
  } catch (error) {
    return null;
  }
};

const initialState = () => {
  const token = window.localStorage.getItem('jwt');

  return {
    jwt: token,
    parsedJWT: parseJWT(token),
    isAuthenticated: false
  };
};

const authModule = {
  state: initialState(),

  mutations: {
    login: (state, token) => {
      state.jwt = token;
      state.parsedJWT = parseJWT(token);
      state.isAuthenticated = true;
      window.localStorage.setItem('jwt', token);
    },

    logout: state => {
      state.jwt = null;
      state.parsedJWT = null;
      state.isAuthenticated = false;
      window.localStorage.removeItem('jwt');
    },

    setAuthenticated: (state, authenticated) => {
      state.isAuthenticated = authenticated;
    }
  },

  getters: {
    jwt: state => {
      return state.jwt;
    },

    isAuthenticated: state => {
      return state.isAuthenticated;
    },

    userRole: state => {
      if (state.parsedJWT) {
        return state.parsedJWT.user.role;
      }

      return null;
    },

    username: state => {
      if (state.parsedJWT) {
        return state.parsedJWT.user.username;
      }

      return null;
    },

    fullUserName: state => {
      if (state.parsedJWT) {
        const { degree, firstName, lastName } = state.parsedJWT.user;
        return `${degree || ''} ${firstName} ${lastName}`;
      }

      return null;
    }
  }
};

export default authModule;
